import {bool} from 'prop-types';
import React, {useEffect, useMemo, useRef} from 'react';
import {useSelector} from 'react-redux';
import {Virtuoso} from 'react-virtuoso';

import ResultsListFooter from './footer.jsx';
import ResultItem from './result-item-v2.jsx';
import {selectFilteredResultIds} from '@explorer/selectors/results';

const ResultsList = ({canDownload}) => {
  const resultsIds = useSelector(selectFilteredResultIds);
  const sortDirection = useSelector(
    state => state.sidebar.resultsSortDirection
  );
  const viewResults = useSelector(state => state.results.viewResults);

  const listRef = useRef();
  const activeResultIdx = useMemo(
    () => resultsIds.findIndex(resultId => viewResults.includes(resultId)),
    [resultsIds, viewResults]
  );

  useEffect(() => {
    // scroll to top if sort direction is updated
    if (listRef.current) {
      listRef.current.scrollToIndex(0);
    }
  }, [sortDirection]);

  const itemRenderer = index => {
    const resultId = resultsIds[index];
    if (resultId) {
      return (
        <ResultItem
          key={resultId}
          resultId={resultId}
          canUserDownload={canDownload}
        />
      );
    }
  };

  return (
    <Virtuoso
      ref={listRef}
      overscan={500}
      initialItemCount={resultsIds.length}
      data={resultsIds}
      fixedItemHeight={158}
      initialTopMostItemIndex={activeResultIdx >= 0 ? activeResultIdx : 0}
      itemContent={itemRenderer}
      components={{
        Footer: ResultsListFooter,
      }}
    />
  );
};

ResultsList.propTypes = {
  canDownload: bool,
};

export default ResultsList;
